import { render } from "./AvatarUpload.vue.js?vue&type=template&id=36ea7a8b!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AvatarUpload.vue?vue&type=template&id=36ea7a8b"
import script from "./AvatarUpload.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AvatarUpload.vue?vue&type=script&lang=js"
export * from "./AvatarUpload.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AvatarUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/user-settings-page/AvatarUpload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36ea7a8b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36ea7a8b', __exports__)) {
    api.reload('36ea7a8b', __exports__)
  }
  
  module.hot.accept("./AvatarUpload.vue.js?vue&type=template&id=36ea7a8b!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AvatarUpload.vue?vue&type=template&id=36ea7a8b", () => {
    api.rerender('36ea7a8b', render)
  })

}


export default __exports__